var _path, _path2, _path3, _path4, _path5, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2395",
    "data-name": "Group 2395",
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.238,
    height: 65.526,
    viewBox: "0 0 62.238 65.526",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M23.978,19.72V31.906h-9.64V19.72H7.1V11.19H31.2v8.53Z",
    transform: "translate(3.258 5.133)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M30.5,17.031H42.967l-11.6,12.2,12.2,12.2H31.113l-11.582-12.2Z",
    transform: "translate(8.958 7.812)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M0,0H62.238V65.526H0Z",
    transform: "translate(0 0)",
    fill: "#00a0e3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M23.685,16.683V27.625H15.03V16.683h-6.5V9.025H30.169v7.658Z",
    transform: "translate(3.914 4.14)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M29.542,14.269H40.734L30.319,25.219,41.271,36.172H30.092l-10.4-10.953Z",
    transform: "translate(9.032 6.545)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M12.981,25.879a.625.625,0,0,1,.47.153.718.718,0,0,1,0,.864.625.625,0,0,1-.47.153.618.618,0,0,1-.467-.153.712.712,0,0,1,0-.864.618.618,0,0,1,.467-.153m-.5,1.893,1.011-.149v4.6H12.476Z",
    transform: "translate(5.673 11.87)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M17.2,27.514a1.781,1.781,0,0,0-1.317-.462,2.241,2.241,0,0,0-.882.156,1.6,1.6,0,0,0-.608.445,1.821,1.821,0,0,0-.353.69,3.307,3.307,0,0,0-.112.89V29.6a3.808,3.808,0,0,0,.105.947,1.619,1.619,0,0,0,.347.684,1.492,1.492,0,0,0,.639.419,2.921,2.921,0,0,0,.973.14c.121,0,.245,0,.373-.013s.251-.022.372-.039.233-.038.335-.061a2.094,2.094,0,0,0,.27-.079l.133-.759c-.232.047-.438.079-.614.1s-.356.026-.538.026a2.189,2.189,0,0,1-.919-.149.785.785,0,0,1-.414-.532l2.6-1.212a.124.124,0,0,0,.074-.123v-.121a1.765,1.765,0,0,0-.464-1.308m-2.067.632a.824.824,0,0,1,.725-.309.837.837,0,0,1,.621.2.958.958,0,0,1,.235.557l-1.8.843v-.279a1.808,1.808,0,0,1,.22-1.017",
    transform: "translate(6.386 12.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M35.178,33.758c-.067-.018-.147-.035-.242-.053a1.624,1.624,0,0,0-.293-.026.97.97,0,0,0-.8.3,1.455,1.455,0,0,0-.247.929V37.4H32.576V32.885l.878-.131.076.616a1.389,1.389,0,0,1,.518-.454,1.669,1.669,0,0,1,.745-.155,1.812,1.812,0,0,1,.3.023,1.519,1.519,0,0,1,.271.074Z",
    transform: "translate(14.941 15.023)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M13.2,31.636l-.117.907H11.354v5.365H10.308V32.544H8.459l.109-.907Z",
    transform: "translate(3.88 14.511)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M17.78,37.323a3.7,3.7,0,0,1-.54.128,3.776,3.776,0,0,1-.556.039,2.524,2.524,0,0,1-.947-.155,1.438,1.438,0,0,1-.6-.441,1.763,1.763,0,0,1-.322-.683,3.739,3.739,0,0,1-.1-.881v-.449A2.977,2.977,0,0,1,14.84,34a1.782,1.782,0,0,1,.372-.678,1.626,1.626,0,0,1,.64-.432,2.575,2.575,0,0,1,.932-.15,3.3,3.3,0,0,1,.616.054,4.1,4.1,0,0,1,.531.131l-.168.776a2.831,2.831,0,0,0-.368-.089,2.592,2.592,0,0,0-.443-.035,1.2,1.2,0,0,0-.929.3,1.538,1.538,0,0,0-.267,1.023v.37a1.564,1.564,0,0,0,.289,1.069,1.265,1.265,0,0,0,.966.314,3.545,3.545,0,0,0,.465-.031c.153-.02.3-.047.43-.076Z",
    transform: "translate(6.75 15.018)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M17.626,38.017V31.551l1.021-.15v2.44a1.353,1.353,0,0,1,.527-.375,1.884,1.884,0,0,1,.7-.127,2.014,2.014,0,0,1,.64.1,1.326,1.326,0,0,1,.5.3,1.344,1.344,0,0,1,.327.5,1.917,1.917,0,0,1,.117.7v3.084h-1.02V35.224a1.249,1.249,0,0,0-.193-.788A.792.792,0,0,0,19.6,34.2a.892.892,0,0,0-.723.273,1.337,1.337,0,0,0-.23.872v2.669Z",
    transform: "translate(8.084 14.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M21.154,37.408V32.9l.878-.133.076.564a1.36,1.36,0,0,1,.54-.445,1.76,1.76,0,0,1,.757-.155,2.014,2.014,0,0,1,.64.1,1.308,1.308,0,0,1,.824.794,1.916,1.916,0,0,1,.118.7v3.084H23.965V34.615a1.259,1.259,0,0,0-.191-.788.792.792,0,0,0-.645-.233.892.892,0,0,0-.723.273,1.345,1.345,0,0,0-.23.872v2.669Z",
    transform: "translate(9.703 15.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M25.227,31.545a.631.631,0,0,1,.473.155.719.719,0,0,1,0,.872.8.8,0,0,1-.945,0,.719.719,0,0,1,0-.872.631.631,0,0,1,.473-.155m-.511,1.912,1.021-.15V37.95H24.716Z",
    transform: "translate(11.286 14.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M27.3,35.916v2.1h-.979V31.55L27.3,31.4v3.721l1.673-1.677H30.13L28.1,35.484l2.109,2.534h-1.2Z",
    transform: "translate(12.073 14.403)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M14.833,33.2a1.8,1.8,0,0,0-1.33-.467,2.28,2.28,0,0,0-.891.158,1.615,1.615,0,0,0-.614.451,1.83,1.83,0,0,0-.356.7,3.314,3.314,0,0,0-.114.9v.37a3.874,3.874,0,0,0,.105.955,1.654,1.654,0,0,0,.352.691,1.5,1.5,0,0,0,.645.423,2.976,2.976,0,0,0,.983.141c.123,0,.248,0,.376-.015s.254-.022.376-.039.236-.038.338-.061a2.147,2.147,0,0,0,.273-.079l.134-.767c-.235.047-.442.08-.62.1s-.359.026-.544.026a2.2,2.2,0,0,1-.928-.15.791.791,0,0,1-.419-.538l2.627-1.224a.126.126,0,0,0,.076-.124v-.123a1.78,1.78,0,0,0-.47-1.322m-2.087.639a.835.835,0,0,1,.732-.314.838.838,0,0,1,.627.209.96.96,0,0,1,.238.562l-1.819.852v-.283a1.821,1.821,0,0,1,.222-1.025",
    transform: "translate(5.288 15.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M32.605,33.2a1.8,1.8,0,0,0-1.33-.467,2.28,2.28,0,0,0-.891.158,1.62,1.62,0,0,0-.616.451,1.849,1.849,0,0,0-.354.7,3.314,3.314,0,0,0-.114.9v.37a3.874,3.874,0,0,0,.105.955,1.654,1.654,0,0,0,.352.691,1.5,1.5,0,0,0,.645.423,2.976,2.976,0,0,0,.983.141c.123,0,.248,0,.376-.015s.254-.022.376-.039.236-.038.338-.061a2.147,2.147,0,0,0,.273-.079l.134-.767c-.235.047-.441.08-.62.1s-.359.026-.544.026a2.21,2.21,0,0,1-.929-.15.793.793,0,0,1-.417-.538L33,34.765a.126.126,0,0,0,.076-.124v-.123a1.785,1.785,0,0,0-.47-1.322m-2.087.639a1.027,1.027,0,0,1,1.359-.105.96.96,0,0,1,.238.562l-1.819.852v-.283a1.821,1.821,0,0,1,.222-1.025",
    transform: "translate(13.439 15.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M8.674,25.969H10.53a3.14,3.14,0,0,1,1.234.207,1.916,1.916,0,0,1,.779.581,2.218,2.218,0,0,1,.407.881,5.015,5.015,0,0,1,.115,1.113v.636a4.754,4.754,0,0,1-.124,1.129,2.308,2.308,0,0,1-.414.882,1.894,1.894,0,0,1-.783.575,3.179,3.179,0,0,1-1.222.206H8.533V26.125a.161.161,0,0,1,.141-.156m.894,5.3h.869a2.2,2.2,0,0,0,.684-.1,1.062,1.062,0,0,0,.489-.318,1.473,1.473,0,0,0,.295-.6,3.739,3.739,0,0,0,.1-.934v-.515a3.914,3.914,0,0,0-.095-.934,1.436,1.436,0,0,0-.29-.6,1.04,1.04,0,0,0-.484-.314,2.249,2.249,0,0,0-.688-.092H9.569Z",
    transform: "translate(3.914 11.912)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/TK.0c7a94db100050084a75168bdccd7775.svg";
export { ForwardRef as ReactComponent };